export function formatBatchLabel(rank?: number | null): string | null {
  const normalizedRank = Number(rank);
  if (!Number.isFinite(normalizedRank) || normalizedRank <= 0) {
    return null;
  }
  return `Batch ${Math.max(1, Math.trunc(normalizedRank))}`;
}

export function replaceGenericBatchCopy(
  text: string | null | undefined,
  rank?: number | null
): string {
  const normalizedText = String(text || "").trim();
  if (normalizedText.length === 0) {
    return "";
  }
  const batchLabel = formatBatchLabel(rank);
  if (!batchLabel) {
    return normalizedText;
  }
  return normalizedText.replace(/\bthis batch\b/gi, batchLabel);
}

export function defaultGeneratingBatchCopy(rank?: number | null): string {
  const batchLabel = formatBatchLabel(rank);
  return batchLabel
    ? `Generating concrete plans for ${batchLabel}...`
    : "Generating concrete plans for this batch...";
}

export function defaultTakingLongerBatchCopy(rank?: number | null): string {
  const batchLabel = formatBatchLabel(rank);
  return batchLabel
    ? `Generating concrete plans for ${batchLabel}. This is taking longer than usual.`
    : "Generating concrete plans for this batch. This is taking longer than usual.";
}

export function defaultRetryingBatchCopy(rank?: number | null): string {
  const batchLabel = formatBatchLabel(rank);
  return batchLabel
    ? `Recovering from a stalled planning run for ${batchLabel}.`
    : "Recovering from a stalled planning run for this batch.";
}

export function defaultFailedBatchCopy(rank?: number | null): string {
  const batchLabel = formatBatchLabel(rank);
  return batchLabel
    ? `Plan generation failed for ${batchLabel}.`
    : "Plan generation failed for this batch.";
}
